export default __webpack_public_path__ + "img/trash.fd7424d2.svg";